import * as React from 'react';

const HeartOutlineIcon = ({ className , color ="#333333" , size ="24px" , style  })=>/*#__PURE__*/ React.createElement("svg", {
        "data-testid": "svg-heart-outline",
        className: className,
        style: style,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21.35C8.35985 18.0362 2 13.9377 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 13.9377 15.6401 18.0362 12 21.35ZM12 18.6454C14.7015 16.1861 20 12.6565 20 8.5C20 6.51695 18.4778 5 16.5 5C14.3913 5 13.2329 6.71438 12 8.15086C10.7671 6.71438 9.60866 5 7.5 5C5.52219 5 4 6.51695 4 8.5C4 12.6571 9.29799 16.1855 12 18.6454Z",
        fill: color
    }));

export { HeartOutlineIcon };
